import { styled } from "styled-components";

export const ContainerEstra = styled.div`
display: flex;
flex-direction: row;
width: 100%;
margin: 30px;
flex-wrap: wrap;
transition: width 3s;
h1 {
  color: black;
  text-align: center;
  margin-bottom: 0px;
  width: 100%;
}
`;


export const ContainerTag = styled.div`
display: flex;
justify-content: center;
flex-wrap: wrap;
align-items: center;
align-content: center;
width: 100%;
height: auto;
margin: 5px;
`;


export const TagEstrategia = styled.span`
margin: 5px;
padding: 7px 16px;
width: auto;
height: 40px;
background-color: gray;
border: 2px solid gray;
border-radius: 20px;
font-weight: bold;
transition: background-color 2s, border-color 2s, position 2s, transform 2s;
&:hover {
    background-color: gray;
    color: white !important;
}
&.piramide-full {
  position: absolute;
  z-index: 2;
}
`;

export const DataPiramide = styled.div`
display: flex;
flex-direction: column;
width: 50%;
height: auto;
justify-content: flex-start;
flex-wrap: wrap;
align-items: center;
align-content: center;
row-gap: 15px;
border-radius: 15px;
padding: 15px;
transition: width 2s;

&.piramide-full {
  width: 100%;
}

`;

export const CustomPiramide = styled.div`

width: 50%;
transition: width 3s;

.piramide {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
}

&.piramide-full {
  width: 100%;
  pointer-events: none;
}



`;

export const LevelButton = styled.button`
  appearance: none;
  background-color: transparent !important;
  padding: 0;
  margin: 0;
  border: none;
  width: 800px;
  position: relative;
  line-height:0;
  transition: width 3s;
  img {
    width: 100%;
  }
  &.piramide-full {
    width: 1200px;
  }

  > span {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto auto;
    height: 30px;
    line-height: 22px;
    font-family: "CIB Sans Bold",sans-serif;
    font-size: 20px;
  }

  &.level-1 {
    width: 200px !important;
  }

  &.level-21 {
    width: 400px !important;
    > span {
      max-width: 340px;
    }
  }

  &.level-22 {
    width: 600px !important;
  }

  &.level-3 {
    width: 807px !important;
    margin-left: 7px;
  }

`;

export const LevelDetail = styled.div`
  position: absolute;
  width: 300px;
  padding: 10px;
  line-height: 18px;
  border-radius: 8px;
  box-sizing: 2px 2px 4px rgba(0,0,0,.5);
  font-family: "Open Sans",sans-serif;

  &.level-1 {
    background-color: #FF7F41;
    top: 0;
    right: -300px;
  }

  &.level-21 {
    background-color: #8F65CD;
    top: 0;
    right: -300px;
  }

  &.level-22 {
    background-color: #00CDEA;
    top: 0;
    right: -300px;
  }

  &.level-3 {
    background-color: #09A783;
    top: 0;
    right: -300px;
  }
`;